import template from "./no-organization-card.html";

const NoOrganizationCard = {
  template: template,

  controller: class NoOrganizationCardController {
    /* @ngInject */
    constructor($rootScope, $window, $scope, $state) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$state = $state;
    }
  },
};
export default NoOrganizationCard;
